import React, { useContext, useEffect, useState } from "react";
import Close from "../../../../../images/Close.svg";
import { Title } from "../../../../../stories/Title/Title";
import { Label } from "../../../../../stories/Label/Label";
import Input from "../../../../../stories/Input/Input";
import TextArea from "../../../../../stories/TextArea/TextArea";
import { LabelProps, TableHeaderProps } from "../../../../../utils/types";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import {
  GridAlignment,
  GridCellParams,
  GridColDef,
  GridValidRowModel
} from "@mui/x-data-grid-pro";
import {
  StyledDatagrid,
  useDataGridStyles
} from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import {
  MaterialRequestStatus,
  Operation,
  PageFor,
  TableHeaders
} from "../../../../../utils/Enum.types";
import { Button } from "../../../../../stories/Button/Button";
import { useLazyQuery } from "@apollo/client";
import { GetMrfTrns } from "../material/queries/queries";

import {
  AtsMrfTrnEdge,
  AtsMrfTrnOrderField,
  GetMrfTrnsResult,
  GetMrfTrnsVars,
  MrfTrnQueryType
} from "../material/queries/types";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import {
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE
} from "../../../../../utils/constants";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../../context/context";
import {
  getModifiedScrollHeight,
  toInputStandardDate
} from "../../../../../utils/UtilFunctions";
import { IObjectKeys } from "../../../../../utils/formTypes";
import Assign from "../../../../../images/Assign.svg";
import Modal from "react-modal";
import { ViewModalStyles } from "../../../../../styles/CustomModalStyles";
import ConfirmOrder from "./ConfirmOrder";
import ViewPendingStatus from "../material/pending/ViewPendingStatus";
import useFormJson from "../../../../../json/useFormJson";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
}

export interface materialData extends IObjectKeys {
  mrfNo: string;
  materialReqFor: string;
  refNo: string;
  date: string;
  mrfRaisedBy: string;
  narration: string;
  mrfCopy: string;
}

interface totalsType {
  required_qty: number;
  approx_rate: number;
  taxable_amt: number;
  net_value: number;
}


const MRFtoPOEntry = ({ setModalFlag, pageType }: Props) => {
  const { Purchase } = useAssetTableJson();
const {viewMaterialRequestOrder}=useFormJson();
  const { headerStyles } = useDataGridStyles();
  const [confirmOrder, setConfirmOrder] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [materialData, setMaterialData] = useState<materialData>({
    mrfNo: "",
    materialReqFor: "",
    refNo: "",
    date: "",
    mrfRaisedBy: "",
    narration: "",
    mrfCopy: ""
  });

  const dynamicHeaders: TableHeaderProps[] = Purchase.Material.MRFtoPo.filter(
    (header) => {
      // Exclude 'actions' column if pageType is View
      if (pageType === PageFor.VIEW && header.field === "actions") {
        return false;
      }
      return true;
    }
  ).map((header) => ({
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    renderCell: (params) => {
      if (header.field === "actions") {
        return (
          <>
            <button
              className="material-view__tableblock--confirm"
              onClick={() => setConfirmOrder(!confirmOrder)}
            >
              Confirm Order <img src={Assign} alt="" />
            </button>
            {/* <button
              className="material-view__tableblock--update"
              onClick={() => setConfirmOrder(!confirmOrder)}
            >
              Update Order <img src={Assign} alt="" />
            </button> */}
          </>
        );
      } else return params.value;
    }
  }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const rows: GridValidRowModel[] = [
    {
      id: 1,
      item_code: "CCTV Camera",
      uom: "",
      description: "",
      present_stock: "",
      required_qty: "",
      approx_rate: "",
      taxable_amt: "",
      tax: "",
      net_value: "",
      priority: "",
      need_before: "",
      prefered_vendor: "",
      used_for: "",
      remark: "",
      accepted: "",
      accepted_qty: "",
      accepted_remark: "",
      mrf_trns_id: ""
    }
  ];

  const getRow = () => {
    if (rows.length) {
      const totals = rows.reduce(
        (acc: totalsType, item) => {
          acc.required_qty = acc.required_qty + item.required_qty;
          acc.approx_rate = acc.approx_rate + item.approx_rate;
          acc.taxable_amt = acc.taxable_amt + item.taxable_amt;
          acc.net_value = acc.net_value + item.net_value;
          return acc;
        },
        {
          required_qty: 0,
          approx_rate: 0,
          taxable_amt: 0,
          net_value: 0
        }
      );

      return [
        {
          id: [],
          item_code: [],
          uom: [],
          description: [],
          present_stock: "",
          required_qty: totals.required_qty,
          approx_rate: totals.approx_rate,
          taxable_amt: totals.taxable_amt,
          tax: [],
          net_value: totals.net_value,
          priority: [],
          need_before: [],
          prefered_vendor: [],
          used_for: [],
          remark: [],
          actions: []
        }
      ];
    }
    return [];
  };

  const pinnedRows = {
    bottom: getRow()
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "required_qty":
        case "approx_rate":
        case "taxable_amt":
        case "net_value":
          return "total-count";
        default:
          return "hide-td";
      }
    }

    return "";
  };

  return (
    <>
      <div className="material-view">
        <div className="material-view__title">
          <Title>MRF to PO Entry</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>

        <div className="material-view__filterblock row g-0">
          <div className="col material-view__filterblock--frame">
            <div className="label-grid">
              {viewMaterialRequestOrder.leftForm.map((data: LabelProps) => {
                return (
                  <>
                    <Label>{data.labelName}</Label>
                    <Input disabled value={materialData[data.inputName]} />
                  </>
                );
              })}
            </div>
          </div>
          <div className="col material-view__filterblock--frame">
            <div className="view-pending__filterblock--frame--grid">
              <Label>Date Request Made</Label>
              <Input type="date" disabled value="11-11-2023" />
            </div>
            <div className=" view-pending__filterblock--flex">
              <div className="view-pending__filterblock--grid">
                <Label>MRF Raised By</Label>
                <Input disabled value="11-11-2023" />
              </div>
              <div className="view-pending__filterblock--grid">
                <Label>MR Scan Copy</Label>
                <Input disabled />
              </div>
            </div>
            <div className="view-pending__filterblock--frame--grid">
              <Label>Remarks</Label>
              <Input disabled />
            </div>
          </div>
        </div>
        <div className={"material-view__tableblock"}>
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            // onCellClick={(params) => {
            //   if (params.field === "months") {
            //     setViewModal(!viewModal);
            //     handleFilterMonthDetails(params.row.month_id);
            //   }
            // }}
            sx={{
              ...headerStyles
            }}
            disableRowSelectionOnClick
            hideFooter
            pinnedRows={pinnedRows}
            getCellClassName={getCellClassName}
            initialState={{
              pinnedColumns: {
                left: ["id", "item_code"],
                right: [
                  "last_supplied_by",
                  "last_supplied_qty",
                  "last_supplied_rate",
                  "ordered_rate",
                  "order_to_supplier",
                  "remarks",
                  "actions"
                ]
              }
            }}
          />
        </div>
        <div className="material__add--datablock">
          <div className="row g-0">
            <div className="col">
              <div className="label-grid">
                <Label>MRF Raised By</Label>
                <Input disabled value={materialData.mrfRaisedBy} />
              </div>
            </div>
            <div className="col">
              <div className="label-grid">
                <Label>MRF Copy</Label>
                <Input disabled />
              </div>
            </div>
          </div>
          <div className="material__add--datablock--grid">
            <Label>Narration</Label>
            <TextArea rows={3} disabled />
          </div>
        </div>
       
          <Button mode="save" onClick={() => setViewModal(!viewModal)} />
        

        <Button mode="clear" />
        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>
      <Modal isOpen={confirmOrder} style={ViewModalStyles} ariaHideApp={false}>
        <ConfirmOrder setModalFlag={setConfirmOrder} />
      </Modal>
      <Modal isOpen={viewModal} style={ViewModalStyles} ariaHideApp={false}>
        <ViewPendingStatus
          setModalFlag={setViewModal}
          pageType={PageFor.VIEW}
          type={MaterialRequestStatus.APPROVED}
        />
      </Modal>
    </>
  );
};

export default MRFtoPOEntry;
